/**
 * What happens once a backoffice login call returns a session (10 § 2.2).
 *
 * Nothing but storing the token: whether this account may see the backoffice
 * at all, and whether it has TOTP, is `Gate`'s question and it asks the server
 * rather than the client.
 */

import type { AuthState } from '@cowoo/shared';
import { useAdminStore } from '../../lib/store';
import { forgetPendingLogin, takeReturnTo } from './pending';

type Authenticated = Extract<AuthState, { status: 'authenticated' }>;

export function afterAuthentication(state: Authenticated): string {
  useAdminStore.getState().setSession(state.token);
  forgetPendingLogin();
  return takeReturnTo();
}
